import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { ApprovalsEquipmentsComponent } from './approvals-equipments.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.EQUIPMENTS.APPROVALS' };
var routes = [
    {
        path: 'equipamentos/aprovacoes',
        component: ApprovalsEquipmentsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var ApprovalsEquipmentsModule = /** @class */ (function () {
    function ApprovalsEquipmentsModule() {
    }
    return ApprovalsEquipmentsModule;
}());
export { ApprovalsEquipmentsModule };
export { ɵ0 };
